<template>
<div class="form__item">
    <label :for="id">
        <slot name="label"></slot>
        <span v-if="required == true" style="color: red;">*</span>
    </label>

    <div v-if="type == 'checkbox' && options">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="option in options" :key="option.id" class="input__checkbox--container-inline">   
               <input 
                  v-model="optionSelected"
                  @change="onOption"
                  :class="inputClass"
                  type="checkbox" 
                  :name="option" 
                  :value="option" 
                  :aria-label="option" 
                  :disabled="disabled" 
                  :required="required">   
                <span class="input__checkbox--text">{{option}}</span>
            </label>
        </div>
        <div v-else>
            <label v-for="option in options" :key="option.id" class="input__checkbox--container">
               <input 
                  v-model="optionSelected"
                  @change="onOption"
                  :class="inputClass"
                  type="checkbox" 
                  :name="option" 
                  :value="option" 
                  :aria-label="option" 
                  :disabled="disabled" 
                  :required="required"> 
                <span class="input__checkbox--text">{{option}}</span>
            </label>
        </div>
    </div>

   <div v-if="type == 'radio' && options">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="option in options" :key="option.id" class="input__radio--container-inline">
                <input 
                @click="setAllFalse"
                @change="onOption"
                v-model="optionSelected" 
                :class="inputClass" 
                type="radio" 
                :name="id" 
                :value='option'  
                :aria-label="option" 
                :disabled="disabled" 
                :required="required" ref='input' >
                <span class="input__radio--text">{{option}}</span>
            </label>
        </div>
        <div v-else>
            <label v-for="option in options" :key="option.id" class="input__radio--container">
                <input 
                @click="setAllFalse"
                @change="onOption"
                v-model="optionSelected" 
                :class="inputClass" 
                type="radio" 
                :name="id" 
                :value='option'  
                :aria-label="option" 
                :disabled="disabled" 
                :required="required" ref='input' >
                <span class="input__radio--text">{{option}}</span>
            </label>
        </div>
   </div>

    <div v-if="type == 'toggle' && options">
        <div v-if="inline == true" class="d-flex-between">
            <label v-for="option in options" :key="option.id" class="input__toggle--container-inline">
                <input 
                  v-model="optionSelected" 
                  @change="onOption"
                  :class="inputClass" 
                  type="checkbox" 
                  :name="option" 
                  :value="option" 
                  :aria-label="option" 
                  :disabled="disabled" 
                  :required="required" 
                  ref='input' >
                <span class="input__toggle--switch"></span>
                <label class="input__toggle--text">{{option}}</label>
            </label>
        </div>
        <div v-else>
            <label v-for="option in options" :key="option.id" class="input__toggle--container">
                <input 
                  v-model="optionSelected" 
                  @change="onOption"
                  :class="inputClass" 
                  type="checkbox" 
                  :name="option" 
                  :value="option" 
                  :aria-label="option" 
                  :disabled="disabled" 
                  :required="required" 
                  ref='input' >
                <span class="input__toggle--switch"></span>
                <label class="input__toggle--text">{{option}}</label>
            </label>
        </div>
    </div>

    <div v-if="type == 'select' && options">
        <label class="input__select--container">
            <select 
               :class="inputClass" 
               v-model="selected"
               @change="onSelect" 
               ref='input' 
               :required="required" 
               :disabled="disabled" 
               aria-label="select" >
               <option disabled value="">Please select one</option>
               <option v-for="(option, key) in options" :value="key" :key="option.id">{{option}}</option>
            </select>
        </label>
    </div>
</div>
</template>

<script>
export default {
   data() {
      return {
         selected: '',
         optionSelected: [],
         selectType: ''
      }
   },
   props: {
      id: { type: String, default: null },
      required: { type: Boolean, default: false },
      autofocus: { type: Boolean, default: false },
      disabled: {type: Boolean, default: false},
      type: {type: String, default: null},
      inline: {type: Boolean, default: false},
      options: {type: Array, default: null}
   },
   mounted() {
      this.autofocus ? this.$refs.input.focus() : ''

      this.defaultValue()
   },
   computed: {
      inputClass() {
         const { type } = this
         return `input__${type}`
      }
   },
   methods: {
      defaultValue() {
         let { type, options, $attrs } = this

         if(type == 'select'){
            if(typeof $attrs.value == 'string') {
               this.selectType = 'string'
               if($attrs.value != '') {
                  for (let i = 0; i < options.length; i++) {            
                     options[i] == $attrs.value ? this.selected = i : null
                  }
               }
            } else {
               this.selectType = 'number'
               this.selected = $attrs.value
            }
         } else if(type == 'checkbox' || type == 'toggle') {
            if(typeof $attrs.value == 'string') {
               if($attrs.value != '') {
                  this.optionSelected.push($attrs.value)
               }
            } else {
               for (let i = 0; i < $attrs.value.length; i++) {
                  this.optionSelected.push($attrs.value[i])
               }
            }
         } else if(type == 'radio') {
            if($attrs.value != '') {
               this.optionSelected = $attrs.value
            }
         }
      },
      onSelect() {
         if(this.selectType == 'string') {
            this.$emit('input', this.options[this.selected])
         } else {
            this.$emit('input', this.selected)
         }
      },
      onOption() {
         this.$emit('input', this.optionSelected)
      },
      setAllFalse () {
         this.optionSelected = ''
         this.$emit('input', '')
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Forms/option.scss';
</style>